var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHead = function SvgHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 345 344"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M279.979 150.5c0-65.151-47.821-117.924-106.979-117.924S66.021 85.35 66.021 150.5c0 21.11 4.952 40.785 13.812 57.985 14.464 28.276 21.5 59.809 21.5 91.603v12.249h143.334v-12.249c0-31.794 6.906-63.327 21.5-91.603 8.73-17.2 13.812-37.006 13.812-57.985Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M179.515 82.09H46.606v157.668h132.909z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M229.03 172.522s63.849-.131 63.849-28.276c0-12.118-14.594-14.203-14.594-14.203"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M292.879 57.25v.17c2.391 0 3.783 1.455 3.783 3.822h.237c0-2.386 1.455-3.822 3.798-3.822v-.17c-2.367 0-3.798-1.455-3.798-3.826h-.237c0 2.376-1.392 3.827-3.783 3.827M32.273 31.19v.17c2.39 0 3.783 1.455 3.783 3.822h.237c0-2.387 1.455-3.822 3.798-3.822v-.17c-2.367 0-3.798-1.455-3.798-3.827h-.237c0 2.377-1.392 3.827-3.783 3.827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 0.8,
    d: "M328.461 177.212a3.509 3.509 0 1 0 7.018 0 3.509 3.509 0 0 0-7.018 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "M1 244.86v.226c3.188 0 5.044 1.94 5.044 5.096h.317c0-3.182 1.94-5.096 5.063-5.096v-.226c-3.156 0-5.063-1.94-5.063-5.102h-.317c0 3.168-1.856 5.102-5.044 5.102ZM256.394 23.344v.227c3.188 0 5.044 1.94 5.044 5.095h.317c0-3.181 1.94-5.095 5.063-5.095v-.227c-3.156 0-5.063-1.94-5.063-5.102h-.317c0 3.169-1.856 5.102-5.044 5.102Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    d: "M313.069 298.269c9.916-8.851 7.248-19.279 3.231-26.646-9.698-17.788-39.008-15.413-36.492-4.472s33.196-5.528 26.444-22.339"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M21.849 287.277v.084c1.195 0 1.891.728 1.891 1.911h.119c0-1.193.727-1.911 1.899-1.911v-.084c-1.184 0-1.9-.728-1.9-1.914h-.118c0 1.189-.696 1.914-1.891 1.914"
  })));
};
export default SvgHead;